import { useQuery } from '@tanstack/react-query';
import {
  type GetDocumentsExternalFilesDownloadRequestType,
  getDocumentExternalFilesDownload,
} from '..';
import { queryKey } from './query-key';

export const useGetDocumentExternalFilesDownload = (
  params: GetDocumentsExternalFilesDownloadRequestType,
) =>
  useQuery(
    queryKey.rendered(params.documentId),
    () => getDocumentExternalFilesDownload(params),
    {
      enabled: Boolean(params.documentId),
      cacheTime: 0,
      staleTime: 0,
    },
  );
